// Refresh failures must not turn an acknowledged save into a failed save.
// Attempt both refreshes so an inaccessible inbox does not prevent the
// currently open conversation from showing the saved note.
export const refreshAfterInternalNoteSave = async (refreshInbox, refreshThread) => {
  const results = await Promise.allSettled([
    Promise.resolve().then(refreshInbox),
    Promise.resolve().then(refreshThread),
  ]);
  return results.every((result) => result.status === "fulfilled");
};
